export enum AdviserClientSessionState {
    ALREADY_HAS_A_SESSION = 'ALREADY_HAS_A_SESSION',
    THERE_IS_NOT_A_SESSION = 'THERE_IS_NOT_A_SESSION',
    SESSION_UPDATED = 'SESSION_UPDATED',
    ERROR = 'ERROR',
}



// WEBPACK FOOTER //
// ./src/app/enums/adviser-client-session-state.ts